import { render, staticRenderFns } from "./FeriadosFilterBar.vue?vue&type=template&id=844f8bde"
import script from "./FeriadosFilterBar.vue?vue&type=script&lang=js"
export * from "./FeriadosFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports